"use client"

import { useState } from "react"
import {
  CalculatorCard,
  CalculatorGrid,
  FormulaNote,
  NumberField,
  ResultStat,
  formatMultiple,
  formatPercent,
  parseNum,
} from "./calculator-ui"

/**
 * ROAS = revenue attributed to ads ÷ ad spend (a multiple).
 * Default example: $5,000 revenue ÷ $1,000 spend = 5× ROAS.
 */
export function RoasWidget() {
  const [revenue, setRevenue] = useState("5000")
  const [adSpend, setAdSpend] = useState("1000")

  const rev = parseNum(revenue)
  const spend = parseNum(adSpend)
  const roas = rev !== null && spend !== null && spend > 0 ? rev / spend : NaN
  const returnPct = Number.isFinite(roas) ? roas - 1 : NaN

  return (
    <CalculatorCard title="ROAS Calculator">
      <CalculatorGrid>
        <NumberField
          id="roas-revenue"
          label="Revenue from ads"
          value={revenue}
          onChange={setRevenue}
          prefix="$"
        />
        <NumberField
          id="roas-spend"
          label="Ad spend"
          value={adSpend}
          onChange={setAdSpend}
          prefix="$"
        />
      </CalculatorGrid>

      <div className="mt-6">
        <ResultStat
          label="Return on ad spend"
          value={formatMultiple(roas)}
          tone={Number.isFinite(roas) ? (roas >= 1 ? "good" : "bad") : "neutral"}
          caption={
            Number.isFinite(roas)
              ? `Every $1 of ad spend returns ${formatMultiple(roas)} in revenue (${formatPercent(returnPct)} net of spend).`
              : "Enter revenue and a non-zero ad spend."
          }
        />
      </div>

      <FormulaNote>ROAS = Revenue from ads ÷ Ad spend. Result is a multiple (e.g. 5× = $5 back per $1 spent).</FormulaNote>
    </CalculatorCard>
  )
}
